<div class="snippet-container">

	<div class="jumbotron text-center m-3">
		<h2>{{snippet.name}}</h2>
		<i class="fa fa-plug"></i>
	</div>
	<div class="text-end mt-2">
		<button class="btn btn-sm btn-danger" (click)="deleteConfirm()">Remove</button>
		<button class="btn btn-sm btn-primary ms-2" (click)="editSnippet()">Edit</button>
	</div>
</div>

<app-confirmation *ngIf="this.confirmationData.open" (complete)="confirmAction($event)" [data]="confirmationData"></app-confirmation>
<app-snippet-edit [snippet]="snippet" (modalAction)="editModalAction($event)" *ngIf="snippetEditModal"></app-snippet-edit>
